import { render, staticRenderFns } from "./EmailWaitlist.vue?vue&type=template&id=3544f856&scoped=true&"
import script from "./EmailWaitlist.vue?vue&type=script&lang=js&"
export * from "./EmailWaitlist.vue?vue&type=script&lang=js&"
import style0 from "./EmailWaitlist.vue?vue&type=style&index=0&id=3544f856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544f856",
  null
  
)

export default component.exports